export const FlexResponsibleGamblingBannerWrapper = {
  '&&': {
    boxShadow: 'none',
  },
};
